import { render, staticRenderFns } from "./PtoRequest.vue?vue&type=template&id=35807861&scoped=true"
import script from "./PtoRequest.vue?vue&type=script&lang=js"
export * from "./PtoRequest.vue?vue&type=script&lang=js"
import style0 from "./PtoRequest.vue?vue&type=style&index=0&id=35807861&prod&scoped=true&lang=css"
import style1 from "./PtoRequest.vue?vue&type=style&index=1&id=35807861&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35807861",
  null
  
)

export default component.exports